import { TouchableIconWithToolTip } from '../../../../utils/meldd-tooltip'
import { useNavigation } from '@react-navigation/native'
import { TargetType } from '../../../../generated/graphql'
import { useTranslation } from 'react-i18next'
import { AppNavigation } from '../../navigation/types'
import { ReviewIcon } from '../../../../utils/meldd-icons'
import { Icon } from 'react-native-paper'

export const ReplayButton = (props: {
  targetId: string
  targetType: TargetType
  size?: number
}) => {
  const { t } = useTranslation('menuItems')
  const navigation = useNavigation<AppNavigation>()
  return (
    <TouchableIconWithToolTip
      icon={<Icon source={ReviewIcon} size={props.size || 24} />}
      mode="text"
      tooltip={t('review')}
      onPress={() =>
        navigation.navigate('ReplayList', {
          targetId: props.targetId,
          targetType: props.targetType,
        })
      }
    />
  )
}
